import {useState} from 'react'
import useApi from '../../../services/useApi'
import {parseInquiryData} from '../utils'

export interface IInquiryDetail {
  id: string
  customerName: string
  email: string
  inquiryDate: string
  sku?: string
  productName?: string
  customerGroup?: string
  salesRep?: string
  notifyEmail?: string
  variantId?: string
}

const useInStockNotifyOperations = () => {
  const Api = useApi()
  const [isLoading, setLoading] = useState(false)
  const [productVariants, setProductVariants] = useState<IInquiryDetail[]>([])

  const getInquiryDetails = async (parentSku: string | null, variantSku?: string | null) => {
    const filters = variantSku ? {variant_sku: variantSku} : {}
    return Api.get(`/analytics/replenishment/products/instock-notify/${parentSku}/details`, {
      filters,
      setLoading: setLoading,
      onSuccess: ({data}) => {
        setProductVariants(parseInquiryData(data?.data || []))
      },
    })
  }

  return {
    productVariants,
    isOperationLoading: isLoading,
    getInquiryDetails,
  }
}

export default useInStockNotifyOperations
